import React from 'react';

import { Row, Col, Space } from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
  LoadingOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

export const checkStatusComponents = {
  loading: (
    <LoadingOutlined className='minimum-requirement__row-icon minimum-requirement__row-icon--blue' />
  ),
  success: (
    <CheckOutlined className='minimum-requirement__row-icon minimum-requirement__row-icon--green' />
  ),
  error: (
    <CloseOutlined className='minimum-requirement__row-icon minimum-requirement__row-icon--red' />
  ),
  warning: (
    <InfoCircleOutlined className='minimum-requirement__row-icon minimum-requirement__row-icon--yellow' />
  ),
};

const MinimumRequirementsRow = ({
  status,
  cols = [15, 9],
  children,
  errorComponent,
  item,
  entityData,
  productDetail,
  updateFormValue,
  hasBrickCode,
  primaryErrors = [],
  minimumRequirementErrorFields = [],
}) => {
  const ErrorComponent = errorComponent;

  return (
    <div className='minimum-requirement__row' id={item?.fieldName}>
      <Row align='middle' gutter={[8, 0]}>
        <Col span={cols[0]}>{children}</Col>
        <Col span={cols[1]}>
          <Space style={{ alignItems: 'center' }}>
            {item?.checkStatus && checkStatusComponents[item?.checkStatus]
              ? checkStatusComponents[item?.checkStatus]
              : null}
            {(status === 'error' || status === 'warning') && errorComponent ? (
              <ErrorComponent
                item={item}
                entityData={entityData}
                productDetail={productDetail}
                updateFormValue={updateFormValue}
                hasBrickCode={hasBrickCode}
                primaryErrors={primaryErrors}
                minimumRequirementErrorFields={minimumRequirementErrorFields}
              />
            ) : null}
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default MinimumRequirementsRow;
